<!--
 * @Description: 创建新企业
 * @Author: ljrong
 * @Date: 2024-05-08 14:35:28
 * @LastEditors: Lxc 1533761120@qq.com
 * @LastEditTime: 2024-07-09 16:39:14
-->
<script lang="ts" setup>
import { FormItemRule } from 'naive-ui'
import { createCompany } from '@/api'
import { useWorkspaceStore, useUserStore } from '@/store'
import { simulateClickOutside } from '@/utils/tool'
const router = useRouter()

const workspaceStore = useWorkspaceStore()
const userStore = useUserStore()

const isNameUsed = ref(false)
const nameErrorText = ref('')
const formRef = ref(null)
const formValue = ref({
    name: ''
})
const rules = {
    name: {
        key: 'name',
        required: true,
        trigger: 'change',
        validator: (rule: FormItemRule, value: string) => {
            return new Promise<void>((resolve, reject) => {
                if (!value) {
                    reject(Error('公司名称不能为空'))
                }

                if (isNameUsed.value) {
                    reject(Error(nameErrorText.value))
                }

                resolve()
            })
        }
    }
}

function onClose() {
    formRef.value.restoreValidation()
    workspaceStore.updateCreateCompanyModal(false)
}

function validatePartial() {
    formRef.value.validate(() => { }, (rule) => rule.key === 'name')
}

function onFocus() {
    isNameUsed.value = false
    formRef.value.restoreValidation()
}
function onComfirmCreate() {
    formRef.value.validate((errors) => {
        if (!errors) {
            createCompany(formValue.value).then(async (res) => {
                workspaceStore.updateCreateCompanyModal(false)
                await workspaceStore.updateWorkspaceList()
                userStore.updateDropMenuInfo()

                window.$message?.success('企业创建成功')

                const workspace = workspaceStore.workspaceList.find(item => item.workspaceName === formValue.value.name)


                // 选择新创建的企业
                workspaceStore.updateCurrentWorkspace(workspace)

                simulateClickOutside()

                formValue.value.name = ''

                router.replace({
                    path: '/workbench', query: {
                        workspace: workspace.workspaceId,
                    }
                }).catch((err) => {
                    if (err.name !== 'NavigationDuplicated') {
                        console.error(err)
                    }
                })
            }).catch(err => {
                isNameUsed.value = true
                nameErrorText.value = err.resultMsg
                validatePartial()
            })

        } else {
            console.log(errors)
        }
    })
}

</script>

<template>
    <CompanyBasicModal title="创建新企业" v-model="workspaceStore.isCreateCompanyModal" @close="onClose">
        <NForm ref="formRef" :label-width="0" :model="formValue" :rules="rules" :size="size">
            <NFormItem path="name">
                <NInput v-model:value="formValue.name" placeholder="请输入企业名称" :maxlength="64" show-count
                    @focus="onFocus" />
            </NFormItem>
        </NForm>
        <template #footer>
            <NSpace justify="end" :size="12">
                <button class="footer-btn cancel-btn" @click="onClose">取消</button>
                <button class="footer-btn button-gradient" @click="onComfirmCreate">确定</button>
            </NSpace>
        </template>
    </CompanyBasicModal>
</template>

<style lang="scss" scoped></style>